<template>
    <div id="app" class="wrapper">

        <div class="loader loader--main" :class="{active: $store.state.mainLoader == true, visible: $store.state.mainLoaderVisible == true}">
            <vimeo-player class="player" v-if="videoId && $store.state.mainLoaderEnable == true" :video-id="videoId" :autoplay="true" :options="videoOptions" @ended="onVideoEnded" @ready="onVideoPlayerReady"></vimeo-player>
        </div>

        <div class="loader" :class="loaderClass" v-if="!isMobile">
            <vimeo-player class="player" v-if="currentVideoLoaderId" :video-id="currentVideoLoaderId" :autoplay="true" :loop="true" :options="videoOptions"></vimeo-player>
        </div>

        <div v-if="videoPlayerReady">
            <aside :class="{hidden: $store.state.mapFullScreen == true || $store.state.menuHidden}">
                <div class="logo-block" v-if="!isMobile">
                    <router-link :to="{ name: 'Home'}" class="logo"></router-link>
                </div>
                <div class="menu">
                  <router-link class="menu__item glitch" :class="{active: currentPage == 'Home'}" :to="{ name: 'Home'}"><span class="glitch-action" :data-text="_('menuHome')">{{ _('menuHome') }}</span></router-link>
<!--                  <router-link class="menu__item glitch" :class="{active: currentPage == 'About'}" :to="{ name: 'About'}">{{ _('menuAbout') }}</router-link>-->
                  <router-link class="menu__item glitch" :class="{active: currentPage == 'Works'}" :to="{ name: 'Works'}"><span class="glitch-action" :data-text="_('menuWorks')">{{ _('menuWorks') }}</span></router-link>
<!--                  <router-link class="menu__item glitch" :class="{active: currentPage == 'Team'}" :to="{ name: 'Team'}"><span class="glitch-action" :data-text="_('menuTeam')">{{ _('menuTeam') }}</span></router-link>-->
                  <router-link class="menu__item glitch" :class="{active: currentPage == 'Contacts'}" :to="{ name: 'Contacts'}"><span class="glitch-action" :data-text="_('menuContacts')">{{ _('menuContacts') }}</span></router-link>
                </div>
                <div class="social" v-if="!isMobile">
<!--                  <div class="social__link glitch"><a :href="_('urlFacebook')" target="_blank"><span class="glitch-action" :data-text="_('socialFacebook')">{{ _('socialFacebook') }}</span></a></div>-->
<!--                  <div class="social__link glitch"><a :href="_('urlInstagram')" target="_blank"><span class="glitch-action" :data-text="_('socialInstagram')">{{ _('socialInstagram') }}</span></a></div>-->
                  <div class="social__link glitch"><a :href="_('urlVimeo')" target="_blank"><span class="glitch-action" :data-text="_('socialVimeo')">{{ _('socialVimeo') }}</span></a></div>
                </div>
                <div class="address" v-if="!isMobile">
                  <div class="address__city">{{ _('addressCity') }}</div>

                  <div class="address__address" v-html="_('address')"></div>
                </div>

                <div class="btns btns--menu" v-if="isMobile">
                  <div class="btn btn--big btn--red-light btn--square" @click="$store.commit('toggleMenu')"><span>{{ _('btnClose') }}</span></div>
                </div>
            </aside>

<!--            <transition :enter-active-class="$store.state.enterClassName" :leave-active-class="$store.state.leaveClassName">-->
<!--                <keep-alive>-->
                    <router-view @loaded="loaded"></router-view>
<!--                </keep-alive>-->
<!--            </transition>-->

          <div class="btns btns--menu" v-if="isMobile" :class="{hidden: $store.state.mapFullScreen || $store.state.hiddenMobileMenuBtn}">
            <div class="btn btn--big btn--blue btn--square" @click="$store.commit('toggleMenu')"><span>{{ _('btnToMenu') }}</span></div>
          </div>
        </div>
    </div>
</template>

<style lang="less">
    @import './assets/css/style.less';
</style>

<style lang="scss">
  @import './assets/css/glitch';
</style>

<script>
  import './assets/css/animate.css'
  import {isMobile} from './mixins/isMobile';
  import {functions} from './mixins/functions';

  export default {
      name: 'App',
      mixins: [isMobile, functions],

      data() {
          return {
              currentPage: 'Home',
              videoLoaderIds: [],
              currentVideoLoaderId: false,
              videoId: false,
              videoPlayerReady: false,
              videoOptions: {
                  background: 1
              }
          }
      },

      created() {
          let _t = this;

          _t.$store.dispatch('loadData', {
              page: 'App'
          });
      },

      mounted() {
          var _t = this;

          if (_t.$store.state.pagesLoaded.App) {
              _t.onMounted();
          } else {
              _t.$store.subscribe((mutation, state) => {
                  if (mutation.type === 'pageLoaded' && mutation.payload.page == 'App') {
                      _t.onMounted();
                  }
              });
          }

          var cursor = $('.cursor');

          $(document).on('mousemove', function(e){
              const render = () => {
                  cursor.css({
                      left:  e.pageX,
                      top:   e.pageY
                  });

                  requestAnimationFrame(render);
              };
              requestAnimationFrame(render);
          });
      },

      watch: {
          isMobile(val) {
              let _t = this;

              if (val) {
                  _t.$store.commit('hideMenu');
              } else {
                  _t.$store.commit('showMenu');
              }
          }
      },

      computed: {
          loaderClass() {
              let _t = this;

              if (_t.$store.state.mainLoader == true) {
                  return {}
              }

              return {active: _t.$store.state.loader == true, visible: _t.$store.state.loaderVisible == true};
          }
      },

      methods: {
          onMounted() {
              let _t = this;

              _t.videoId = _t._('preloadVideoId');
              _t.videoLoaderIds = _t._('preloadShortVideosIds');
              _t.currentVideoLoaderId = _t.videoLoaderIds[_t.randomInteger(0, _t.videoLoaderIds.length - 1)];
          },
          onVideoEnded() {
              this.$store.commit('mainLoaderOFF');
          },
          onVideoPlayerReady() {
              let _t = this;

              _t.videoPlayerReady = true;
          },
          onLoaderReady() {
              this.$store.commit('loaderReadyON');
          },
          loaded(data) {
              var _t = this;

              _t.currentPage = data.page ? data.page : false;
              _t.currentVideoLoaderId = _t.videoLoaderIds[_t.randomInteger(0, _t.videoLoaderIds.length - 1)];

              if (_t.isMobile) {
                  _t.$store.commit('hideMenu');
              }
          },
      }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue